/* Bernard James — "Contact advisor" opens live chat (Dev QA sheet, QA-PDP).

   Loaded on every page (layout/theme.liquid, QA-PDP block) because the bag
   drawer's "Contact us" uses it too.

   window.bjOpenAdvisorChat(opts) -> boolean
     Opens the first live-chat widget the page has loaded and returns true, or
     returns false when there is none, so the caller can follow its link to
     the contact page instead. opts.source ('pdp', 'bag', ...) is passed to
     the 'bj:advisor-chat' event for analytics; nothing else reads it.

   As of 2026-10-22 bernardjames.com loads HubSpot's Conversations embed
   (portal 245288253, conversations-embed.js) on every page, but no chatflow
   targets the storefront: HubSpot's livechat-public API answers HIDE_WIDGET /
   NO_MATCHING_WELCOME_MESSAGE, so widget.status().loaded stays false and
   widget.load() never completes. There is no Shopify Inbox, Gorgias, Tidio,
   Zendesk or Intercom. So today every call returns false and the links are
   followed. Publishing a chatflow that targets the site makes the buttons
   open it, with no theme change.

   Rule for every opener: hand off ONLY when a widget is really there to open.
   Claiming the click on a widget that is merely embedded (2026-10-22 bug: the
   PDP "Contact advisor" did nothing on the live site) leaves the visitor with
   a dead button, since the click's default has already been cancelled.

   The PDP button opts in with data-bj-advisor="chat" (buy_buttons block
   setting "Secondary button action"); the handler below is delegated so it
   also covers markup re-rendered by the variant picker. */
(function () {
  'use strict';

  function fn(value) {
    return typeof value === 'function';
  }

  // Each opener returns true only when it actually handed off to a widget.
  var OPENERS = [
    {
      name: 'hubspot',
      open: function () {
        var hs = window.HubSpotConversations;
        if (!hs || !hs.widget || !fn(hs.widget.open)) return false;
        // The embed object exists on every page once Conversations is
        // installed; the widget itself only loads when a chatflow targets
        // this page and visitor. When it has not loaded, HubSpot has either
        // hidden it (HIDE_WIDGET) or is still deciding, and a load() +
        // widgetLoaded hand-off never resolves in the first case — so treat
        // "not loaded" as "no chat" and let the caller follow its link.
        var status = fn(hs.widget.status) ? hs.widget.status() : null;
        if (!status || status.loaded !== true) return false;
        hs.widget.open();
        return true;
      }
    },
    {
      // Shopify Inbox has no public "open" API; its launcher is a button in an
      // open shadow root on the <inbox-online-store-chat> element.
      name: 'shopify-inbox',
      open: function () {
        var host = document.querySelector('inbox-online-store-chat');
        var root = host && host.shadowRoot;
        if (!root) return false;
        var button =
          root.querySelector('button.chat-toggle') ||
          root.querySelector('button[aria-label*="chat" i]') ||
          root.querySelector('button');
        if (!button) return false;
        button.click();
        return true;
      }
    },
    {
      name: 'gorgias',
      open: function () {
        var g = window.GorgiasChat;
        if (!g || !fn(g.open)) return false;
        g.open();
        return true;
      }
    },
    {
      name: 'tidio',
      open: function () {
        var t = window.tidioChatApi;
        if (!t || !fn(t.open)) return false;
        if (fn(t.show)) t.show();
        t.open();
        return true;
      }
    },
    {
      name: 'zendesk',
      open: function () {
        if (!fn(window.zE)) return false;
        try {
          window.zE('messenger', 'open');
        } catch (e) {
          window.zE('webWidget', 'open');
        }
        return true;
      }
    },
    {
      name: 'intercom',
      open: function () {
        if (!fn(window.Intercom)) return false;
        window.Intercom('show');
        return true;
      }
    },
    {
      name: 'tawk',
      open: function () {
        var t = window.Tawk_API;
        if (!t || !fn(t.maximize)) return false;
        t.maximize();
        return true;
      }
    },
    {
      name: 'livechat',
      open: function () {
        var l = window.LiveChatWidget;
        if (!l || !fn(l.call)) return false;
        l.call('maximize');
        return true;
      }
    },
    {
      name: 'crisp',
      open: function () {
        var c = window.$crisp;
        if (!c || !fn(c.push)) return false;
        c.push(['do', 'chat:open']);
        return true;
      }
    },
    {
      name: 'freshchat',
      open: function () {
        var f = window.fcWidget;
        if (!f || !fn(f.open)) return false;
        f.open();
        return true;
      }
    }
  ];

  window.bjOpenAdvisorChat = function (opts) {
    var source = (opts && opts.source) || 'unknown';
    for (var i = 0; i < OPENERS.length; i++) {
      var opened = false;
      try {
        opened = OPENERS[i].open();
      } catch (err) {
        opened = false;
      }
      if (opened) {
        document.dispatchEvent(
          new CustomEvent('bj:advisor-chat', { detail: { source: source, provider: OPENERS[i].name } })
        );
        return true;
      }
    }
    return false;
  };

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var trigger = event.target.closest && event.target.closest('[data-bj-advisor="chat"]');
    if (!trigger) return;
    if (window.bjOpenAdvisorChat({ source: trigger.getAttribute('data-bj-advisor-source') || 'pdp' })) {
      event.preventDefault();
    }
  });
})();
